import { Component, Input, OnInit } from '@angular/core';
import { SkeletonTypeEnum } from './skeleton.enum';

@Component({
	selector: 'app-skeleton',
	templateUrl: './skeleton.component.html',
	styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent implements OnInit {
	skeletonOptions = SkeletonTypeEnum;

	@Input() total = 1;
	@Input() type: SkeletonTypeEnum = SkeletonTypeEnum.POST_COVER;

	constructor() {
	}

	ngOnInit(): void {
	}

	numSequence(n: number): number[] {
		return Array(n);
	}
}
